import React from 'react';
import { useAnalytics } from '../../hooks/useAnalytics';

/**
 * Analytics Provider Component
 * Initializes analytics tracking within the Router context
 */
const AnalyticsProvider = ({ children }) => {
  // Initialize analytics tracking
  useAnalytics();

  return <>{children}</>;
};

export default AnalyticsProvider;
